import React from 'react'
import { Card } from "react-bootstrap";

function NotInfo() {
  return (
    <div>
           <Card className='rgc-cards w-75 m-auto'>
              <Card.Body className="rgc-cards-alert">
                <i className='fas fa-exclamation-circle' style={{ fontSize: "40px", color: "red" }}></i>
                <Card.Text className='rgc-lists text-center pt-3'>
                  <div className='rgc-lists-txt'>اطلاعاتی موجود نیست</div>
                </Card.Text>
              </Card.Body>
            </Card>
    </div>
  )
}

export default NotInfo